export default {
  "content": "<path d=\"M8 0a8 8 0 100 16A8 8 0 008 0zm.8 12H7.2V7.2h1.6V12zm0-6.4H7.2V4h1.6v1.6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "#BBB",
    "viewBox": "0 0 16 16"
  }
};